package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.data.repository.PlayerRepository
import br.com.texeratx.boardgametimeapp.data.repository.UploadRepository
import br.com.texeratx.boardgametimeapp.domain.usecases.player.CreatePlayerUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.player.DeletePlayerUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.player.GetPlayerDetailUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.player.GetPlayerDetailsUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.player.GetPlayersUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.player.UpdatePlayerUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.upload.UploadPlayerImageUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.players.PlayersViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.players.create.CreatePlayerViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.players.detail.PlayerDetailViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.players.edit.EditPlayerViewModel
import org.koin.dsl.module

val playersModule = module {

    factory { PlayerRepository(get(), get()) }

    factory { GetPlayersUseCase(get()) }

    factory { PlayersViewModel(get()) }

    factory { CreatePlayerViewModel(get(), get(), get()) }

    factory { EditPlayerViewModel(get(), get(), get(), get()) }

    factory { GetPlayerDetailUseCase(get()) }
    factory { GetPlayerDetailsUseCase(get()) }
    factory { DeletePlayerUseCase(get()) }

    factory { PlayerDetailViewModel(get(), get()) }

    factory { UpdatePlayerUseCase(get()) }

    factory { CreatePlayerUseCase(get()) }

    factory { UploadPlayerImageUseCase(get()) }

    factory { UploadRepository(get(), get()) }


}
